import { useEffect, useState } from 'react';

export const HostWindowVisibilityEventName = 'pipeex:dockable-pane-visibility';

export type HostWindowVisibilityWindow = Window & {
  __PIPEEX_DOCKABLE_PANE_VISIBLE__?: boolean;
};

export function readHostWindowVisibility(): boolean {
  if (typeof window === 'undefined') {
    return true;
  }

  const hostWindow = window as HostWindowVisibilityWindow;
  return typeof hostWindow.__PIPEEX_DOCKABLE_PANE_VISIBLE__ === 'boolean'
    ? hostWindow.__PIPEEX_DOCKABLE_PANE_VISIBLE__
    : true;
}

export function useHostWindowVisibility(): boolean {
  const [isVisible, setIsVisible] = useState(readHostWindowVisibility);

  useEffect(() => {
    const handleVisibility = (event: Event) => {
      const detail = (event as CustomEvent<{ visible?: unknown }>).detail;
      if (typeof detail?.visible === 'boolean') {
        setIsVisible(detail.visible);
      }
    };

    window.addEventListener(HostWindowVisibilityEventName, handleVisibility);
    setIsVisible(readHostWindowVisibility());

    return () => {
      window.removeEventListener(HostWindowVisibilityEventName, handleVisibility);
    };
  }, []);

  return isVisible;
}
